import {createSlice} from "@reduxjs/toolkit";

const initialInstrumentsState = {
  isLoading: false,
  data: [],
  notification: null
};

export const instrumentsSlice = createSlice({
  name: "instruments",
  initialState: initialInstrumentsState,
  reducers: {
    // Instrument Responses
    instrumentNotification: (state, action) => {
      state.isLoading = false;
      state.notification = action.payload.notification;
    },
    // Instrument Loading
    isLoading: (state, action) => {
      state.isLoading = true;
    },

    // fetchInstruments
    instrumentsFetched: (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    },
  }
});
